import i18n from "utils/i18n/i18n";

import {
  showErrorNotification,
  showSuccessNotification,
} from "./customNotifications";

/** Saving changes of a waypoint failed (the waypoint is shown as it's saved again) */
export const showWaypointUpdateFailedNotification = () =>
  showErrorNotification({
    title: i18n.t("generic.error_title"),
    message: i18n.t("errors.updating_waypoint_failed.text"),
  });

/** Saving a new waypoint failed (it's removed from the map again) */
export const showWaypointCreationFailedNotification = () =>
  showErrorNotification({
    title: i18n.t("generic.error_title"),
    message: i18n.t("errors.cannot_create_waypoint"),
  });

type Props = {
  name?: string;
  count?: number;
};
export const showWaypointExportSuccessNotification = ({
  name,
  count,
}: Props) => {
  if (!name && !count)
    throw new Error(
      "Export success notification requires either count or name"
    );
  const title = i18n.t("notifications.waypoint.successful_export.title");
  const message = count
    ? i18n.t("notifications.waypoint.successful_export.with_count.message", {
        waypointsCount: count,
      })
    : i18n.t("notifications.waypoint.successful_export.with_name.message", {
        name,
      });
  showSuccessNotification({
    message,
    title,
  });
};
export const showWaypointDeletionSuccessNotification = ({
  name,
  count,
}: Props) => {
  if (!name && !count)
    throw new Error(
      "Delete success notification requires either count or name"
    );
  const title = i18n.t("notifications.waypoint.successful_delete.title");
  const message = count
    ? i18n.t("notifications.waypoint.successful_delete.with_count.message", {
        waypointsCount: count,
      })
    : i18n.t("notifications.waypoint.successful_delete.with_name.message", {
        name,
      });
  showSuccessNotification({
    message,
    title,
  });
};
